export const usersSubscriptionGroupData = "/users/subscription_group_data";
